import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import ViewTripDetailsContent from "./ViewTripDetailsContent";

const ViewTripDetailsDialog = ({ open, onOpenChange, tripDetails, loading }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Trip Details</DialogTitle>
        </DialogHeader>
        <ViewTripDetailsContent 
          tripDetails={tripDetails}
          loading={loading}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ViewTripDetailsDialog;